export default __webpack_public_path__ + "static/media/ic-dash.ea873578.svg";